import React from "react";
import logo from "assets/img/logo.png";

const Logo = () => <img src={logo} alt="logo" width="100%" height="100%"></img>;

export default Logo;
